import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectBox } from 'cbc-shared-lib';
import { Sgke351aResponseInitialhyojiInfo, Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo } from 'sg-api';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke350d-condition',
  templateUrl: './sgke350d-condition.component.html',
  styleUrl: './sgke350d-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke350dConditionComponent implements OnInit, OnDestroy {

  /** 会社地区情報 */
  @Input() cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 初期表示用会社地区情報 */
  @Input() cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** 初期表示情報 */
  @Input() initialhyojiInfo: Sgke351aResponseInitialhyojiInfo;
  /** 業務日付 */
  @Input() businessDate: Date = null;

  /** クリアボタン押下イベント */
  @Output() onClickClearEvent = new EventEmitter();

  /** 検索条件フォーム */
  searchConditionForm: UntypedFormGroup;


  /** 会社リスト */
  companyList: SelectBox[] = [];
  /** 地区（供給地点）リスト */
  areaSuppntList: SelectBox[] = [];
  /** 拠点リスト */
  baseList: SelectBox[] = [];
  /** 作業担当者リスト */
  workTntshList: SelectBox[] = [];

  /** 親FormGroup */
  parentForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {UntypedFormBuilder} fb
   * @param {ListSearchUtils} listSearchUtils
   * @memberof Sgke350dConditionComponent
   */
  constructor(
    private parent: FormGroupDirective,
    private fb: UntypedFormBuilder,
    private listSearchUtils: ListSearchUtils,
  ) {
  }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke350dConditionComponent
   */
  ngOnInit(): void {

    // セレクターに値をセットする
    this.companyList = this.getCompanyAreaSelector('companycode', 'companycodeAname');
    // 拠点リスト取得
    this.baseList = this.getBaseListSelector();

    // 地区（供給地点）リスト初回作成
    //（フォーム作成前にリストを作成しなければ、地区（供給地点）リストの初期値を設定できないため）
    this.areaSuppntList = this.cmpnyAreaList
      .filter(list => list.companycode == this.listSearchUtils.getListboxValue(this.cmpnyAreaInit?.companycode, this.companyList))
      .map(data => {
        const select: SelectBox = { value: data.areacode, viewValue: data.areacodeAname };
        return (select);
      });

    /** FormGroup */
    this.searchConditionForm = this.fb.group({
      supplyresumptionPlndateStart: this.fb.nonNullable.control({ value: null, disabled: false }),
      supplyresumptionPlndateEnd: this.fb.nonNullable.control({ value: this.businessDate, disabled: false }, Validators.required),
      companycode: this.fb.nonNullable.control({ value: this.listSearchUtils.getListboxValue(this.cmpnyAreaInit?.companycode, this.companyList), disabled: false }, Validators.required),
      areaSuppntCode: this.fb.nonNullable.control({ value: this.listSearchUtils.getListboxValue(this.cmpnyAreaInit?.areacode, this.areaSuppntList), disabled: false }, Validators.required),
      workTntsh: this.fb.group({
        staffCode: this.fb.nonNullable.control({ value: null, disabled: true }),
        staffKanjiName: this.fb.nonNullable.control({ value: null, disabled: false }),
        baseCode: this.fb.nonNullable.control({ value: null, disabled: false }),
      })
    });

    // 地区（供給地点）リストを設定
    this.onChangeCompany(false);

    // FormGroupの登録
    this.parentForm = this.parent.form;
    // 親コンポーネントのformに検索条件formを追加
    this.parentForm.addControl("cndt", this.searchConditionForm);


  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke350dConditionComponent
   */
  ngOnDestroy(): void {
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('cndt');
  }

  /**
   * クリアボタン押下時処理
   * @public
   * @returns {void}
   * @memberof Sgke350dConditionComponent
   */
  public onClickClear(): void {
    this.searchConditionForm.reset();
    this.onChangeCompany(false);
    this.onClickClearEvent.emit();
  }

  /**
   * 会社ドロップダウン変化時処理
   * @public
   * @param {string} companycode
   * @param {boolean} [isNotInitialDisplay=true] 
   * @returns {void}
   * @memberof Sgke350dConditionComponent
   */
  public onChangeCompany(isNotInitialDisplay: boolean = true): void {
    // 会社コードリストの値が変わった場合

    // 会社コード
    const companycode = this.getControl('companycode').value;
    // 地区（供給地点）
    const areaCtl = this.getControl('areaSuppntCode') as UntypedFormControl;

    if (isNotInitialDisplay) {
      // 初期表示、クリアの場合、地区（供給地点）には初期値が設定されているため、未選択状態に設定しない
      // 地区（供給地点）を未選択状態に設定
      areaCtl?.setValue(null);
    }

    this.areaSuppntList = this.cmpnyAreaList
      .filter(list => list.companycode == companycode)
      .map(data => {
        const select: SelectBox = { value: data.areacode, viewValue: data.areacodeAname };
        return (select);
      });
  }

  /**
   * 拠点ドロップダウン変化時処理
   * @public
   * @returns {void}
   * @memberof Sgke350dConditionComponent
   */
  public onChangeBase(): void {
    const baseCode = this.getControl('workTntsh').get('baseCode').value;
    // 社員コードコントロール
    const staffCode = this.getControl('workTntsh').get('staffCode');
    // 社員漢字氏名
    const staffKanjiName = this.getControl('workTntsh').get('staffKanjiName');

    // 作業担当者リストを未選択状態に設定
    staffCode.setValue(null);
    staffKanjiName.setValue(null);

    // 未選択 or 取得NGの場合
    if (!baseCode) {
      staffCode.disable();
      return;
    } else {
      staffCode.enable();
    }

    // 拠点に紐づく作業担当者リスト更新
    this.workTntshList = this.initialhyojiInfo.workTntshList
      .filter(list => list.baseCode == baseCode)
      .map(data => {
        const select: SelectBox = { value: data.staffCode, viewValue: data.staffKanjiName };
        return (select);
      });

  }

  /**
   * 作業担当者ドロップダウン変化時処理
   * @public
   * @param {string} staffCode
   * @returns {void}
   * @memberof Sgke350dConditionComponent
   */
  public onChangeWorkTntsh(staffCode: string): void {
    // 社員漢字氏名取得
    const staffKanjiName = this.getControl('workTntsh').get('staffKanjiName') as UntypedFormControl;
    // 社員漢字氏名設定
    const selected = this.workTntshList.filter(list => list.value == staffCode);
    staffKanjiName.setValue(selected.length > 0 ? selected[0].viewValue : null);
  }

  /**
   * 拠点リスト取得
   * @private
   * @returns { SelectBox[]}
   * @memberof Sgke350dConditionComponent
   */
  private getBaseListSelector(): SelectBox[] {

    let selectBox: SelectBox[] = [];

    this.initialhyojiInfo.baseList.map(data => {
      const select: SelectBox = { value: data.codeValue, viewValue: data.aname };
      selectBox.push(select);
    });

    return selectBox;
  }

  /**
   * コントロール取得
   * @private
   * @param {string} ctrlName
   * @return {UntypedFormControl}
   * @memberof Sgke350dConditionComponent
   */
  private getControl(ctrlName: string): UntypedFormControl {
    return this.searchConditionForm.get(ctrlName) as UntypedFormControl;
  }

  /**
   * SGKE903Aレスポンスからセレクターにオプションをセット
   * @private
   * @param {string} value
   * @param {string} viewValue
   * @return {*}
   * @memberof Sgke350dConditionComponent
   */
  private getCompanyAreaSelector(value: string, viewValue: string): any {

    // SGKE903Aレスポンスのコードとコード値をまとめてリスト化
    let retSelectBoxList: SelectBox[] = [];
    this.cmpnyAreaList.map(data => {
      const select: SelectBox = { value: data[value], viewValue: data[viewValue] };
      retSelectBoxList.push(select);
    });

    // 重複を削除しソート
    const uniqueSortedArray = Array.from(
      new Map(retSelectBoxList.map(item => [item.value, item])).values()
    ).sort((a, b) => a.value > b.value ? 1 : -1);

    return uniqueSortedArray;
  }

}
